import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=1bbb24fa&scoped=true&"
import script from "./Application.vue?vue&type=script&lang=ts&"
export * from "./Application.vue?vue&type=script&lang=ts&"
import style0 from "./Application.vue?vue&type=style&index=0&id=1bbb24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb24fa",
  null
  
)

export default component.exports